import axios from '@/axios';
import * as types from '../mutation-types';

export default {
	namespaced: true,

	state: {
		positions: [],
		workLocations: [],
	},

	actions: {
		// /api/Settings/JobDescriptions
		// ---- job positions
		async fetchAllPositions({ commit }) {
			return axios.get('/Settings/JobDescriptions').then(({ data }) => {
				commit(types.ALL_POSITIONS, data);
				return data;
			});
		},
		async addPosition(_, { name }) {
			return axios
				.post('/Settings/JobDescription', name, { headers: { 'Content-Type': 'application/json' } })
				.then(({ data }) => data);
		},

		updatePosition(_, { id, name }) {
			return axios.put(`/Settings/JobDescription/${id}`, name, { headers: { 'Content-Type': 'application/json' } })
		},

		// ---- work positions
		async fetchAllWorkPositions({ commit }) {
			return axios.get('/Helper/WorkLocations').then(({ data }) => {
				commit(types.ALL_WORK_LOCATIONS, data);
				return data;
			});
		},
		async addWorkPositionType(_, { id, name }) {
			return axios.postput('/Settings/WorkPlaces', id, { name });
		},
		async addWorkPosition(_, { id, workPlaceId }) {
			return axios.put(`/Employee/${id}/WorkPlace`, [workPlaceId]);
		},

		delete({ commit }, { id }) {
			return axios.delete(`/Settings/JobDescription/${id}`)
		}
	},

	mutations: {
		[types.ALL_POSITIONS](state, positions) {
			state.positions = positions;
		},
		[types.ALL_WORK_LOCATIONS](state, workLocations) {
			state.workLocations = workLocations;
		},
	},

	getters: {
		getPositionById: state => id => state.positions.find(c => c.id === id)
	}
};
